import { createReducer } from '@reduxjs/toolkit';

import * as splashScreenActions from './splashScreenActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: 0,
  type: 'splashScreens',
  isActive: false,
  isAdded: false,

  actionType: 1,
  buttonTitle: '',
  buttonUrl: '',

  title: '',
  description: '',
  mediaUrl: '',
  sectionType: 1,

  productSelect: 'last',
  productId: 0,

  ctaActionType: '',
  ctaSite: '',
  ctaSiteText: 'Website',
  ctaBackgroundColor: '#000000',
  ctaBackgroundColorRGBA: '',
  ctaTextColor: '#ffffff',
  ctaIsBorder: false,
  ctaOpacity: 0,
  ctaItemId: 0,
  ctaBlockId: 0,
  ctaPageId: 0,
  ctaObject: {},
};

const splashScreen = createReducer(initialState, (builder) => {
  builder
    .addCase(splashScreenActions.splashScreenUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(splashScreenActions.splashScreenUpdateIsAdded, (state, { payload: isAdded }) => ({ ...state, isAdded }))
    .addCase(splashScreenActions.splashScreenUpdateIsActive, (state, { payload: isActive }) => ({ ...state, isActive }))

    .addCase(splashScreenActions.splashScreenStore, (state, { payload }) => {
      const {
        uid,
        isActive,

        data,
      } = payload;

      const section = data ?? {};
      const {
        id,

        buttonAction,
        buttonTitle,
        buttonUrl,
        description,
        mediaUrl,
        title,
        type,
        productSelect,
        productId,

        ctaType,
        ctaUrl,
        ctaTitle,
        ctaBackgroundColor,
        ctaBackgroundRGBA,
        ctaTextColor,
        ctaIsBorder,
        ctaOpacity,
        ctaItemId,
        ctaPageId,
        ctaObject,
        ctaBlockId,
      } = section;

      return {
        ...state,

        error: null,
        requesting: false,

        id,
        uid,
        isActive,
        isAdded: Boolean(id),

        actionType: buttonAction ?? 1,
        buttonTitle,
        buttonUrl,

        title,
        description,
        mediaUrl,
        sectionType: type ?? 1,

        productSelect,
        productId,

        ctaActionType: ctaType ?? '',
        ctaSite: ctaUrl ?? '',
        ctaSiteText: ctaTitle ?? 'Website',
        ctaBackgroundColor: ctaBackgroundColor ?? '#000000',
        ctaBackgroundColorRGBA: ctaBackgroundRGBA ?? '',
        ctaTextColor: ctaTextColor ?? '#ffffff',
        ctaIsBorder: ctaIsBorder ?? false,
        ctaOpacity: ctaOpacity ?? 0,
        ctaItemId: ctaItemId ?? 0,
        ctaBlockId: ctaBlockId ?? 0,
        ctaObject: ctaObject ?? {},
        ctaPageId: ctaPageId ?? 0,
      };
    })
    .addCase(splashScreenActions.splashScreenClear, () => ({ ...initialState }))

    .addCase(splashScreenActions.splashScreenUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(splashScreenActions.splashScreenUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(splashScreenActions.splashScreenUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(splashScreenActions.splashScreenUpdateTitle, (state, { payload: title }) => ({ ...state, title }))
    .addCase(splashScreenActions.splashScreenUpdateDescription, (state, { payload: description }) => ({ ...state, description }))
    .addCase(splashScreenActions.splashScreenUpdateMediaUrl, (state, { payload: mediaUrl }) => ({ ...state, mediaUrl }))
    .addCase(splashScreenActions.splashScreenUpdateSectionType, (state, { payload: sectionType }) => ({ ...state, sectionType }))

    .addCase(splashScreenActions.splashScreenUpdateProductSelect, (state, { payload: productSelect }) => ({ ...state, productSelect }))
    .addCase(splashScreenActions.splashScreenUpdateProductId, (state, { payload: productId }) => ({ ...state, productId }))
    .addCase(splashScreenActions.splashScreenUpdateCTAActionType, (state, { payload: ctaActionType }) => ({ ...state, ctaActionType }))
    .addCase(splashScreenActions.splashScreenUpdateCTASite, (state, { payload: ctaSite }) => ({ ...state, ctaSite }))
    .addCase(splashScreenActions.splashScreenUpdateCTASiteText, (state, { payload: ctaSiteText }) => ({ ...state, ctaSiteText }))
    .addCase(splashScreenActions.splashScreenUpdateCTABackgroundColor, (state, { payload: ctaBackgroundColor }) => ({ ...state, ctaBackgroundColor }))
    .addCase(splashScreenActions.splashScreenUpdateCTABackgroundColorRGBA, (state, { payload: ctaBackgroundColorRGBA }) => ({ ...state, ctaBackgroundColorRGBA }))
    .addCase(splashScreenActions.splashScreenUpdateCTATextColor, (state, { payload: ctaTextColor }) => ({ ...state, ctaTextColor }))
    .addCase(splashScreenActions.splashScreenUpdateCTAIsBorder, (state, { payload: ctaIsBorder }) => ({ ...state, ctaIsBorder }))
    .addCase(splashScreenActions.splashScreenUpdateCTAOpacity, (state, { payload: ctaOpacity }) => ({ ...state, ctaOpacity }))
    .addCase(splashScreenActions.splashScreenUpdateCTAItemId, (state, { payload: ctaItemId }) => ({ ...state, ctaItemId }))
    .addCase(splashScreenActions.splashScreenUpdateCTABlockId, (state, { payload: ctaBlockId }) => ({ ...state, ctaBlockId }))
    .addCase(splashScreenActions.splashScreenUpdateCTAPageId, (state, { payload: ctaPageId }) => ({ ...state, ctaPageId }));
});

export default splashScreen;
